import React, { Component } from 'react';
import { Chip, Icon, Snackbar } from '@material-ui/core';
import { Alert, Col, Modal, ModalBody, Row } from 'reactstrap';
import store from '../../store';
import ApiEndpoints from "../../constants/api_endpoints";
import { setError, setLoader } from '../../actions/action-creators';
import Button from 'reactstrap/lib/Button';
import SelectList from '../global/form/select';
import CONSTANTS from '../../constants';
import { TrackEvent } from "../../actions/ga"
import moment from 'moment';
import ReactDatePicker from 'react-datepicker';


class OutboundCustomerCallingStatus extends Component {
	constructor(props) {
		super(props);
		this.timer = 0;
		this.state = {
		  callTimer: 0,
		  callDetails : {},
		  commentType: "Callback",
		  commentValue: null,
		  commentText: null,
		  isLoadingInfo: true,
		  showOnlyStatus: true,
		  isOpenUserModel: null
		  }
		}
	componentDidMount() {
		TrackEvent("CALL", "CALL_CUSTOMER_INITIATED", "CALL_CUSTOMER_INIT");
		this.fetchCallStatus();
		this.timer = setInterval(this.callTimer, 1000);
	}
	componentWillUnmount() {
		clearInterval(this.interval);
		clearInterval(this.timer);
	}
	
	callTimer = () => {
		this.setState({ callTimer: this.state.callTimer+1 });
		if( (this.state.callTimer >= 20 && this.state.callDetails.status === "in-progress") || this.state.callDetails.status === "completed"){
			this.setState({ showOnlyStatus: false })
		}
		if(this.state.callDetails.status !== "in-progress") clearInterval(this.timer);
	}


	fetchCallStatus = async () => {
		try{
			var body = { call_id : this.props.calling_id }
			
			var resp = await ApiEndpoints.Calling.fetchOutboundCustomerCall(body);
			let callDetails = resp.data.data || {};
			await this.setState({callDetails});

			this.setState({isLoadingInfo: false});

			if(this.props.onUpdateCall) this.props.onUpdateCall(resp.data.data)

			if(resp.data.data.status === "in-progress"){
				this.interval = setTimeout(this.fetchCallStatus, 5000);
			}
		}
		catch(e){
			this.props.onClose && this.props.onClose();
			store.dispatch(setError({show: true, message: typeof e.response.data.message === "string" ? e.response.data.message :  "Not able to fetch call details"}))
		}
	}

	closeCall = async () => {
		let { callDetails, commentType, commentValue, commentText } = this.state;
		store.dispatch(setLoader(true))
		try{
			if(!commentType) throw new Error("Mandatory: Select call comment");
			
			commentValue = commentValue || CONSTANTS.CALL_COMMENTS[commentType].defaultValue
			var callLogsBody = {
				call_log_customer_id : callDetails.call_log_customer_id,
				comment: `${commentType}-${commentText || (CONSTANTS.CALL_COMMENTS[commentType].type === "DATE_TIME" ? moment(commentValue).utcOffset("+05:30").format("Do MMM'YY HH:mm") : commentValue) }`
			};
			await ApiEndpoints.Calling.updateCallCustomerData(callLogsBody)

			this.props.onClose();

		}
		catch(e){
			store.dispatch(setError({show: true, message: typeof e.response.data.message === "string" ? e.response.data.message :  "Not able to fetch call details"}))
		}
		store.dispatch(setLoader(false));
	}



	render() {
		let user = store.getState().user;
		let jobList = store.getState().jobList;
		let { customerData = {}, remark="" } = this.props;
		let { callDetails , commentType, commentValue } = this.state;

		return (
			<Modal size="lg" isOpen={true} style={{zIndex: 1200}}>
				<ModalBody>
					<Row noGutters className="border-bottom align-items-center text-center pb-3 mb-3">
						<Col xs={12} lg={4}>
							<span className='border p-1 mr-3' style={{borderRadius: "50%"}}><Icon fontSize="small" className="align-middle">support_agent</Icon></span>
							<span className='font-weight-bold'>{user.first_name}</span>
						</Col>
						<Col xs={12} lg={4} className="text-center">
							<div className='bg-success py-1 text-light'  style={{borderRadius: 20}}>
								<Icon fontSize="small" className="align-middle mr-3">phone_in_talk</Icon>
								<span className='font-weight-bold'>{callDetails.status}</span>
								<span className='mr-2 float-right'>{this.state.callTimer}</span>
							</div>
						</Col>
						<Col xs={12} lg={4} >
							<span className='border p-1 mr-3' style={{borderRadius: "50%"}}><Icon fontSize="small" className="align-middle">person</Icon></span>
							<span className='font-weight-bold'>{customerData.name}</span>
						</Col>
						{!!remark && 
						<Col xs={12} className="text-center">
							<span className='' style={{fontSize: 12}}>Remark: {remark}</span>
						</Col>
						}
					</Row>
				
					<div className='text-center mt-2'><Button onClick={() => this.props.onClose()} color="danger" size="sm" >Close</Button></div>
{/* 
				{
				this.state.showOnlyStatus || this.props.isSkipCallFeedback  ?
					<div className='text-center mt-2'><Button onClick={() => this.props.onClose()} color="danger" size="sm" >Close</Button></div>
					:
				
					<>
						<Row className="border-top border-bottom py-3 align-items-center">
							<Col md={6} xs={12}>
								<SelectList size="small" search={true} value={commentType} placeholder="Partner Status" onChange={(e) => this.setState({commentType: e.target.value, commentValue: null, commentText: null})}>
									{
										Object.keys(CONSTANTS.CALL_COMMENTS).map((reason, i) => 
										<option value={reason}> {reason} </option> 
									)}
								</SelectList>
							</Col>
							{CONSTANTS.CALL_COMMENTS[commentType].type === "DATE_TIME" && 
							<Col md={6} xs={12}>
								<ReactDatePicker 
									selected={commentValue ? moment(commentValue).toDate() : CONSTANTS.CALL_COMMENTS[commentType].defaultValue}
									onChange={date => this.setState({commentValue : date})}
									showTimeSelect
									className=""
									placeholderText={CONSTANTS.CALL_COMMENTS[commentType].label}
									timeFormat="HH:mm"
									timeIntervals={15}
									timeCaption="time"
									dateFormat="dd-MMM-yyyy HH:mm"
								/>
							</Col>}
							{CONSTANTS.CALL_COMMENTS[commentType].type === "ENUM" && 
							<Col md={6} xs={12}>
								<SelectList size="small" search={true} value={commentValue || CONSTANTS.CALL_COMMENTS[commentType].defaultValue} placeholder={CONSTANTS.CALL_COMMENTS[commentType].label} onChange={(e) => this.setState({commentValue: e.target.value})}>
									{
										CONSTANTS.CALL_COMMENTS[commentType].values.map((v, i) => 
										<option value={v}> {v} </option> 
									)}
								</SelectList>
							</Col>}
							{!CONSTANTS.CALL_COMMENTS[commentType].type && <Col xs={12} className="mt-2"><textarea onChange={(e) => this.setState({commentText: e.target.value})} className="form-control w-100" rows="2" placeholder='Enter call summery' /></Col> }

						</Row>
						<div className='text-center mt-2'>
							<Button onClick={() => this.closeCall()} color="danger" size="sm" >{this.state.commentId ? "Save & Close" : "Save"}</Button>
						</div>
					</>
				} */}
				
				</ModalBody>
			</Modal>
		)
	}
}

export default OutboundCustomerCallingStatus;
